import { doGETRequest, doPOSTRequest, doPUTRequest } from "./Api";

class BuyerWarehouseApi {
  private static basePath = "/buyers/warehouses";

  public static async listBuyerWarehouses(buyerId: number) {
      return await doGETRequest(`${this.basePath}?buyerId=${buyerId}`);
  }

  public static async listAllBuyerWarehouses() {
    return await doGETRequest(this.basePath);
  }

  public static async createBuyerWarehouse(data: any) {
    return await doPOSTRequest(this.basePath, data);
  }

  public static async updateBuyerWarehouse(data: any) {
    return await doPUTRequest(this.basePath, data);
  }

  public static async createOrUpdateWarehouse(data: any) {
    if (data.id) {
      return this.updateBuyerWarehouse(data);
    }
    return this.createBuyerWarehouse(data);
  }
}

export default BuyerWarehouseApi;
